/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import { Switch } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import type { Route } from './config'
import { Routes } from './Routes'

interface RouterProps {
  routes: Route[]
}

export const Router = ({ routes }: RouterProps) => {
  const { isAuthenticated } = useAuth()

  console.log('isAuthenticated:', isAuthenticated)

  return (
    <Switch>
      {routes && routes.map((r) => <Routes key={r.path} {...r} />)}
    </Switch>
  )
}
